import { API, deleteRequest, getRequest, patchRequest, postRequest, putRequest } from '@/api/api';
import { invalidateAuthorizedFile } from '@/utils/file-links';

import type {
  Berth,
  BerthBodyDto,
  BerthFileSlot,
  BerthListDto,
  BerthValues,
} from './vessel-marinas.dto';
import { mapBerth, mapBerthBody } from './vessel-marinas.mappers';

// ponytail: one page of 100 — a vessel with more berths than that is not a case yet.
export const getBerths = async (vesselId?: string): Promise<Berth[]> => {
  const { data } = await getRequest<BerthListDto>(
    API.VESSEL,
    'marina?limit=100&page=1',
    false,
    undefined,
    vesselId,
  );
  return data.items.map(mapBerth);
};

export const createBerth = async (values: BerthValues, vesselId?: string): Promise<string> => {
  const { data } = await postRequest<{ id: string }, BerthBodyDto>(
    API.VESSEL,
    'marina',
    mapBerthBody(values),
    false,
    vesselId,
  );
  return data.id;
};

export const updateBerth = async (id: string, values: BerthValues) => {
  await putRequest<unknown, BerthBodyDto>(API.VESSEL, `marina/${id}`, mapBerthBody(values));
};

export const deleteBerth = async (id: string) => {
  await deleteRequest(API.VESSEL, `marina/${id}`);
};

/** Uploading into a slot that already holds a file replaces it on the backend. */
export const uploadBerthFile = async (id: string, slot: BerthFileSlot, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  await patchRequest(API.VESSEL, `marina/${id}/${slot}`, formData);
  invalidateAuthorizedFile();
};

export const deleteBerthFile = async (id: string, slot: BerthFileSlot) => {
  await deleteRequest(API.VESSEL, `marina/${id}/${slot}`);
};
